import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Directory from "@/pages/Directory";
import Leave from "@/pages/Leave";
import Approvals from "@/pages/Approvals";
import Profile from "@/pages/Profile";
import Payroll from "@/pages/Payroll";
import UsersAdmin from "@/pages/UsersAdmin";
import InquiriesInbox from "@/pages/InquiriesInbox";
import File201List from "@/pages/file201/File201List";
import File201Detail from "@/pages/file201/File201Detail";
import Memos from "@/pages/Memos";
import Loans from "@/pages/Loans";
import OvertimeFile from "@/pages/OvertimeFile";
import OvertimeRecord from "@/pages/schedules/OvertimeRecord";
import ActivitySchedule from "@/pages/schedules/ActivitySchedule";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
      <Route path="/directory" element={<ProtectedRoute><Layout><Directory /></Layout></ProtectedRoute>} />
      <Route path="/leave" element={<ProtectedRoute><Layout><Leave /></Layout></ProtectedRoute>} />
      <Route path="/payroll" element={<ProtectedRoute><Layout><Payroll /></Layout></ProtectedRoute>} />
      <Route path="/memos" element={<ProtectedRoute><Layout><Memos /></Layout></ProtectedRoute>} />
      <Route path="/loans" element={<ProtectedRoute><Layout><Loans /></Layout></ProtectedRoute>} />
      <Route path="/overtime" element={<ProtectedRoute><Layout><OvertimeFile /></Layout></ProtectedRoute>} />
      <Route path="/schedules/overtime" element={<ProtectedRoute allow={["admin", "manager", "supervisor"]}><Layout><OvertimeRecord /></Layout></ProtectedRoute>} />
      <Route path="/schedules/activity" element={<ProtectedRoute allow={["admin", "manager", "supervisor"]}><Layout><ActivitySchedule /></Layout></ProtectedRoute>} />
      <Route path="/approvals" element={<ProtectedRoute allow={["admin", "manager"]}><Layout><Approvals /></Layout></ProtectedRoute>} />
      <Route path="/file201" element={<ProtectedRoute allow={["admin", "manager"]}><Layout><File201List /></Layout></ProtectedRoute>} />
      <Route path="/file201/:eid" element={<ProtectedRoute allow={["admin", "manager"]}><Layout><File201Detail /></Layout></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Layout><Profile /></Layout></ProtectedRoute>} />
      <Route path="/users" element={<ProtectedRoute allow={["admin"]}><Layout><UsersAdmin /></Layout></ProtectedRoute>} />
      <Route path="/inquiries" element={<ProtectedRoute allow={["admin"]}><Layout><InquiriesInbox /></Layout></ProtectedRoute>} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
